var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("Source and verify reliable suppliers across Africa")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Minimise the risk and confirm the credibility and performance of your suppliers with Asoko’s  on-demand research and company verification across the continent. We deliver\n    reliable and authentic insight into private corporates in Africa’s most dynamic economies and the people who run them, including their executives, directors and shareholders."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openSolutions },
          },
          [_vm._v("Learn More")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }